import React from "react";
import i18n from "../../../../utils/ChrI18n";
import ChrLink from "../../../generic/Utils/ChrLink";
import ModalAndTooltip from "../../../../interfaces/ModalAndTooltip";

const EditAlert = (props) => {
  const {
    editAlertPath,
    label = i18n.t("display_string.Edit"),
    iconClass = "fa fa-pen-to-square",
    onTrigger = () => {}
  } = props;

  const onEdit = () => {
    onTrigger();
    editAlertPath && ModalAndTooltip.showManagementReportModal(editAlertPath);
  }

  return (
    <ChrLink noHref className="text-info" onClick={onEdit}>
      <i className={`${iconClass} m-r-xs`} />
      <span>{label}</span>
    </ChrLink>
  );
}

export default EditAlert;